module.exports = __webpack_public_path__ + "img/87c6364.png";